<template>
  <Dialog v-model:visible="show" size="md">
    <template #title>
      <slot name="title" />
    </template>
    <div class="p-4">
      <slot :close="() => (show = false)" />
    </div>
  </Dialog>
</template>

<script setup lang="ts">
const me = useMe();
const { did, isDone } = useDids();

const route = useRoute();

const props = defineProps<{
  id: string;
}>();

const emit = defineEmits(["onClose"]);

const show = ref(false);

onMounted(() => {
  setTimeout(() => {
    if (
      me.value.status === Status.SUCCESS &&
      me.value.data.finished_welcome &&
      !isDone(props.id)
    ) {
      show.value = true;
    }
  }, 1000);
});

watch(me, () => {
  setTimeout(() => {
    if (
      me.value.status === Status.SUCCESS &&
      me.value.data.finished_welcome &&
      !isDone(props.id)
    ) {
      show.value = true;
    }
  }, 1000);
});

watch(show, (value) => {
  if (!value) {
    did(props.id);
  }
});
</script>
